import * as React from 'react';
import { Typography, Grid } from '@mui/material';

export const Separator = ({ sx, text }) => {
  return (
    <Grid sx={{ ...styles.container, ...sx }}>
      <hr style={styles.lines} />
      <Typography sx={styles.text}>{text}</Typography>
      <hr style={styles.lines} />
    </Grid>
  );
};

const styles = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  lines: {
    flexGrow: '1',
    backgroundColor: '#DDDEE4',
    height: '1px',
    border: 'none',
  },
  text: {
    paddingLeft: '20px',
    paddingRight: '20px',
  },
};
